import React, { ReactNode, useContext, useEffect, useRef } from 'react';
import TopBarContent from './NewLayout/TopBarContent';
import { MasterLayoutContext } from '../../../state/MasterLayoutProvider';
import NewLayout from './NewLayout';

interface MasterLayoutProps {
  children: ReactNode[] | ReactNode;
  sidebarCollapsed?: boolean;
  forceNewNavigation?: boolean;
  customTopBarContent?: ReactNode;
  hideAvatar?: boolean;
  isNewMerklistePage?: boolean;
  hideTopBar?: boolean;
}

const MasterLayout: React.FC<
  MasterLayoutProps
> = ({
  children,
  sidebarCollapsed = false,
  customTopBarContent,
  hideAvatar = false,
  isNewMerklistePage = false,
  hideTopBar = false,
}) => {
  const mainContentRef = useRef(null);
  const { setMainContentContainer } = useContext(MasterLayoutContext);

  useEffect(() => {
    setMainContentContainer(mainContentRef.current);
  },[setMainContentContainer]);
  
  return (
    <NewLayout
      topBarContent={
        hideTopBar ? null :
          <TopBarContent customTopBarContent={customTopBarContent} hideAvatar={hideAvatar} />
      }
      mainContentRef={mainContentRef}
      sidebarCollapsed={sidebarCollapsed}
      isNewMerklistePage={isNewMerklistePage}
    >
      {children}
    </NewLayout>
  );
};

export default MasterLayout;
